import { Api } from '@/services/Api'

const lib = {}

lib.getGenerationData = (plantId, device, params) => {
  return Api().get(`/api/v2/live/computed/${plantId}/${device}/${params}`)
}

lib.getLiveDeviceData = (plantId, device, params) => {
  return Api().get(`/api/v2/live/${plantId}/${device}/${params}`)
}

lib.getParameterMapConfig = (param) => {
  return Api().post('/api/v2/live/param-config', param)
}

lib.getDeviceIdMap = (param) => {
  return Api().post('/api/v2/live/config', param)
}

lib.getComputedData = (param) => {
  return Api().post('/api/v2/live/computed-devices', param)
}

export default lib
